import { render, staticRenderFns } from "./section-form.vue?vue&type=template&id=7cfdc010&scoped=true"
import script from "./section-form.vue?vue&type=script&lang=js"
export * from "./section-form.vue?vue&type=script&lang=js"
import style0 from "./section-form.vue?vue&type=style&index=0&id=7cfdc010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfdc010",
  null
  
)

export default component.exports